import React, { memo } from 'react'
import { Link, LinkProps, Text, BoxProps } from '@chakra-ui/core'
import { FiFile } from 'react-icons/fi'
import { extractFileName, openInCloudViewer } from 'utils'
import { IconBaseProps } from 'react-icons'

interface IProps extends LinkProps {
  fileUrl: string
  fileName?: string
  textProps?: BoxProps
  iconProps?: IconBaseProps
}
const FilePreview = memo(({ fileUrl, fileName, textProps, iconProps, ...props }: IProps) => {
  return (
    <Link
      display="flex"
      flexDir="column"
      width="100px"
      bg="#d9d9d9"
      height="100px"
      alignItems="center"
      justifyContent="space-evenly"
      borderRadius="10px"
      cursor="pointer"
      href={openInCloudViewer(fileUrl)}
      target="_blank"
      rel="noopener noreferrer"
      textDecor="none"
      color="black"
      _hover={{ textDecoration: 'none', color: 'black' }}
      _focus={{ boxShadow: 'none', outline: 'none', color: 'black', textDecoration: 'none' }}
      {...props}
    >
      <FiFile size={40} {...iconProps} />
      <Text maxW="80px" fontSize="12px" isTruncated {...textProps}>
        {fileName || extractFileName(fileUrl)}
      </Text>
    </Link>
  )
})

export default FilePreview
